import React from 'react';

export default class ModalContent extends React.Component {
  constructor(props) {
    super();
    this.state = {
    };
  }

	render() {
        const { title, message, onShow, handleModal } = this.props;
        if(onShow !== undefined && !onShow)
            return (null);

        if(message) {
          return (
              <div className="modal-block modal-header-color modal-block-primary">
                  <section className="card">
                      <header className="card-header">
                          <h2 className="card-title">{title}</h2>
                      </header>
                      <div className="card-body">
                          <div className="modal-wrapper">
                              <div className="modal-icon">
                                  <i className="fas fa-question-circle"></i>
                              </div>
                              <div className="modal-text">
                                  <h4>{message}</h4>
                              </div>
                          </div>
                      </div>
                      <footer className="card-footer">
                          <div className="row">
                              <div className="col-md-12 text-right">
                                  <button className="btn btn-primary modal-confirm" onClick={() => handleModal(this)}>Confirm</button>
                                  <button className="btn btn-default modal-dismiss" onClick={this.props.onHide}>Cancel</button>
                              </div>
                          </div>
                      </footer>
                  </section>
              </div>
            )
        } else {
            return (null)
        }
	}
}
